module.exports = __webpack_public_path__ + "img/vox_1.be6200da.png";